import cn from 'classnames';
import { FC, ReactNode } from 'react';

import { RenderPreviewSettings } from '@/shared/config';
import { ViewMIR } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { useIsPseudoFullscreen } from '@/entities/toolbarMIR';

import styles from './PanoReportRender.module.scss';

type PanoReportRenderProps = {
  className?: string;
  children?: ReactNode;
  previewSettings?: RenderPreviewSettings;
};

export const PanoReportRender: FC<PanoReportRenderProps> = (props) => {
  const { className, children, previewSettings } = props;

  const isPseudoFullscreen = useIsPseudoFullscreen();

  return (
    <div data-component="pano-report-render" style={{ display: 'contents' }}>
      <ViewMIR
        viewName="main"
        id="report_render"
        className={cn(
          styles.container,
          previewSettings?.isPreview ? styles.preview : '',
          isPseudoFullscreen && styles.pseudoFullscreen,
          className,
        )}
      >
        {children}
      </ViewMIR>
    </div>
  );
};
